import { render, staticRenderFns } from "./DataQualityReport.vue?vue&type=template&id=b034fb0a"
import script from "./DataQualityReport.vue?vue&type=script&lang=js"
export * from "./DataQualityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports